import { render, staticRenderFns } from "./OrderConfirm.vue?vue&type=template&id=0b481eab&scoped=true&lang=pug&"
import script from "./OrderConfirm.vue?vue&type=script&lang=js&"
export * from "./OrderConfirm.vue?vue&type=script&lang=js&"
import style0 from "./OrderConfirm.vue?vue&type=style&index=0&id=0b481eab&prod&lang=sass&"
import style1 from "./OrderConfirm.vue?vue&type=style&index=1&id=0b481eab&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b481eab",
  null
  
)

export default component.exports